module.exports = __webpack_public_path__ + "img/new_day_sign.14d29ecf.png";